// This file is auto-generated by scripts/generate-revision.js
// Do not edit manually - changes will be overwritten on next build

export const REVISION = '69c8f27ad (staging)';
export const VERSION = '0.16.13';
